import {
  AssemblyTypeValue,
  InstallationStatus,
  JobFormDataBackflow,
  RpCheck2Type,
  TestResult,
} from '../../types/jobFormData';
import { initTestForm } from './evaluate';
import {
  assemblyTypeKey,
  isTestable,
  validateTestDate,
  validateTestTimestamp,
} from './helpers';

export type TestStatus = 'PASS' | 'FAIL' | 'REMOVED' | 'INCOMPLETE';

export const getTestStatus = (
  testAttempt: TestResult,
  backflowAssemblyType: AssemblyTypeValue,
  rpCheck2Type: RpCheck2Type
): TestStatus => {
  if (!assemblyTypeKey(backflowAssemblyType)) {
    throw new Error(
      `Assembly type ${backflowAssemblyType} is not yet supported`
    );
  }

  if (
    validateTestDate(testAttempt.testDate).length > 0 ||
    validateTestTimestamp(testAttempt.timestamp).length > 0
  ) {
    return 'INCOMPLETE';
  }

  const form = initTestForm(testAttempt, backflowAssemblyType, rpCheck2Type);
  if (!form.completed) return 'INCOMPLETE';
  return form.passing ? 'PASS' : 'FAIL';
};

export const getFinalTestStatus = (
  testData: JobFormDataBackflow,
  rpCheck2Type: RpCheck2Type
): TestStatus => {
  if (testData.installationStatus === InstallationStatus.REMOVED) {
    return 'REMOVED';
  }

  if (
    !testData.backflowAssembly ||
    !testData.backflowAssembly.type ||
    !isTestable(testData)
  ) {
    return 'INCOMPLETE';
  }

  const tests = testData.tests;
  if (tests && tests.length > 0) {
    let result: TestStatus = 'INCOMPLETE';
    tests.forEach((testAttempt) => {
      if (testData.backflowAssembly?.type && testAttempt.type !== 'repair') {
        result = getTestStatus(
          testAttempt,
          testData.backflowAssembly.type,
          rpCheck2Type
        );
      }
    });
    return result;
  }

  return 'INCOMPLETE';
};
